import { FC } from 'react';
import { DateTime } from 'luxon';
import { Skeleton } from '@mui/material';
import CartItem from './Item';
import { dineroFormat } from 'src/common/utils/dataFormat';
import { IOrderFetch } from 'src/models/IOrder';
import './styles.scss';

interface IProps {
  order: IOrderFetch;
}

const CartData: FC<IProps> = ({ order }) => {
  const { extras, van, price, currency, end_date, start_date, fee_list } = order;

  let days = Math.ceil(
    DateTime.fromISO(end_date!).diff(DateTime.fromISO(start_date!), ['days']).toObject().days!
  );
  if (days && days <= 1) {
    days = 1;
  }

  const sortedFees = fee_list.sort(function (a, b) {
    if (a.id < b.id) return -1;
    if (a.id > b.id) return 1;
    return 0;
  });

  const _orderItems = () => (
    <>
      {van ? (
        <CartItem item={van} title='van' days={days} />
      ) : (
        <Skeleton width='100%' height='55px' />
      )}
      {extras && sortedFees.map((extra, i) => <CartItem item={extra} title='extra' index={i} />)}
    </>
  );

  return (
    <>
      <div className='order-show__title'>Articles</div>
      <div className='order-cart__wrapper'>{_orderItems()}</div>
      <div className='order-cart__wrapper-total'>
        <div className='order-cart__wrapper-total__info'>
          Incl. All Fees:
          <div className='extra-card__price'>{`Total ${dineroFormat(price, currency)}`}</div>
        </div>
      </div>
    </>
  );
};

export default CartData;
